import { render, staticRenderFns } from "./subordinateModel.vue?vue&type=template&id=23339602&scoped=true"
import script from "./subordinateModel.vue?vue&type=script&lang=js"
export * from "./subordinateModel.vue?vue&type=script&lang=js"
import style0 from "./subordinateModel.vue?vue&type=style&index=0&id=23339602&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23339602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23339602')) {
      api.createRecord('23339602', component.options)
    } else {
      api.reload('23339602', component.options)
    }
    module.hot.accept("./subordinateModel.vue?vue&type=template&id=23339602&scoped=true", function () {
      api.rerender('23339602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/menuManage/subordinateModel.vue"
export default component.exports